export const generateNewsTags = (t) => ([
  { key: 'event', value: 'event', text: t('event') },
  { key: 'jobFair', value: 'jobFair', text: t('jobFair') },
  { key: 'misc', value: 'misc', text: t('misc') },
  { key: 'associationLife', value: 'associationLife', text: t('associationLife') },
  { key: 'roundTable', value: 'roundTable', text: t('roundTable') },
  { key: 'priceAndRewards', value: 'priceAndRewards', text: t('priceAndRewards') },
]);